import $ from 'jquery';

// Bootstrap 3 still reads jQuery from the browser global.
window.$ = window.jQuery = $;
export default $;
